import { render, staticRenderFns } from "./AgentCorpChooseTable.vue?vue&type=template&id=b6693dee&scoped=true&"
import script from "./AgentCorpChooseTable.vue?vue&type=script&lang=js&"
export * from "./AgentCorpChooseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6693dee",
  null
  
)

export default component.exports